import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import * as attendanceAPI from "../../api/attendance";
import { toast } from "react-toastify";

const initialState = {
  studentAttendance: null,
  staffAttendance: null,
  fileUrl: null,
  loading: false,
  currentIndex: null,
  lastAdded: null,
  studentName: null,
  studentAttendancePercentage: null,
  studentAttendancePercentageDateRangeDepartmentWise: null,
  studentAttendancePercentageYearWise: null,
  perPage: 10,
  page: 1,
  offset: 0,
};

const getStudentAttendance = createAsyncThunk(
  "attendance/getStudentAttendance",
  async (params, { rejectWithValue }) => {
    try {
      const res = await attendanceAPI.getStudentAttendance(params);
      if (res.data.statusCodeValue >= 400) {
        // alert();
        return rejectWithValue(res.data.body.error);
      }
      //console.log("getStudentAttendance", res.data.body);
      return res.data.body;
    } catch (error) {
      // alert("catch");
      return rejectWithValue(error);
    }
  }
);

const saveStudentAttendance = createAsyncThunk(
  "attendance/saveStudentAttendance",
  async (params, { rejectWithValue }) => {
    try {
      const res = await attendanceAPI.saveStudentAttendance(params.data);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return { res: res.data.body, params };
    } catch (error) {
      // alert("catch");
      return rejectWithValue(error);
    }
  }
);

const updateStudentAttendanceStaff = createAsyncThunk(
  "attendance/updateStudentAttendanceStaff",
  async (params, { rejectWithValue }) => {
    try {
      const res = await attendanceAPI.updateStudentAttendanceStaff(params);
      if (res.data.statusCodeValue >= 400) {
        // alert();
        return rejectWithValue(res.data.body.error);
      }
      //console.log("updateStudentAttendanceStaff", res.data.body);
      return res.data.body;
    } catch (error) {
      // alert("catch");
      return rejectWithValue(error);
    }
  }
);

const uploadStudentAttendance = createAsyncThunk(
  "attendance/uploadStudentAttendance",
  async (params, { rejectWithValue }) => {
    try {
      const res = await attendanceAPI.uploadStudentAttendance(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const downloadTemplate = createAsyncThunk(
  "attendance/downloadTemplate",
  async (params, { rejectWithValue }) => {
    try {
      const res = await attendanceAPI.downloadTemplate(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getStudentAttendanceDetails = createAsyncThunk(
  "attendance/getStudentAttendanceDetails",
  async (params, { rejectWithValue }) => {
    try {
      const res = await attendanceAPI.getStudentAttendanceDetails(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getStaffAttendanceDetails = createAsyncThunk(
  "attendance/getStaffAttendanceDetails",
  async (params, { rejectWithValue }) => {
    try {
      const res = await attendanceAPI.getStaffAttendanceDetails(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getAttendancePercentage = createAsyncThunk(
  "attendance/getAttendancePercentage",
  async (params, { rejectWithValue }) => {
    try {
      const res = await attendanceAPI.getAttendancePercentage(params);
      console.log("res+", res);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getStudentAttendancePercentageDateRangeDepartmentWise = createAsyncThunk(
  "attendance/getStudentAttendancePercentageDateRangeDepartmentWise",
  async (params, { rejectWithValue }) => {
    try {
      const res =
        await attendanceAPI.getStudentAttendancePercentageDateRangeDepartmentWise(
          params
        );
      console.log("res+", res);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
const getStudentAttendancePercentageYearWise = createAsyncThunk(
  "attendance/getStudentAttendancePercentageYearWise",
  async (params, { rejectWithValue }) => {
    try {
      const res = await attendanceAPI.getStudentAttendancePercentageYearWise(
        params
      );
      console.log("res+", res);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    resetStudentAtttendance: (state, action) => {
      state.studentAttendance = [];
    },

    resetStaffAtttendance: (state, action) => {
      state.staffAttendance = [];
    },

    resetUrl: (state) => {
      state.fileUrl = initialState.fileUrl;
    },
    getCurrentData: (state, action) => {
      const index = state.studentAttendance.findIndex(
        (_el) => _el.idStudent === action.payload.id
      );
      state.currentIndex = index;
      //console.log("index", index, action.payload.data);
      if (action.payload.type === "forenoonStatus") {
        state.studentAttendance[index].forenoonStatus =
          action.payload.data === "Present" ? "1" : "0";
      }
      if (action.payload.type === "afternoonStatus") {
        state.studentAttendance[index].afternoonStatus =
          action.payload.data === "Present" ? "1" : "0";
      }
    },
    clearIndex: (state) => {
      state.currentIndex = initialState.currentIndex;
    },
    addStudentData: (state, action) => {
      const { data, studentData, departmentData } = action.payload;
      const copiedData = JSON.parse(JSON.stringify(data));
      const currentStudent = studentData.findIndex(
        (_el) => _el.idStudent === data.idStudent
      );
      const currentDepartment = departmentData.findIndex(
        (_el) => _el.id === data.idDepartment
      );
      copiedData.studentName = studentData[currentStudent].firstName;
      copiedData.departmentName = departmentData[currentDepartment].name;
      return {
        ...state,
        studentAttendance: [copiedData, ...state.studentAttendance],
      };
    },
    setStudentName: (state, action) => {
      state.studentName = action.payload;
    },
    clearStudentAttendancePercentage: (state) => {
      state.studentAttendancePercentage = null;
      state.studentAttendancePercentageDateRangeDepartmentWise = null;
      state.studentAttendancePercentageYearWise = null;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: {
    [getStudentAttendance.pending]: (state) => {
      state.loading = true;
    },
    [getStudentAttendance.fulfilled]: (state, action) => {
      state.loading = false;
      state.studentAttendance = action.payload;
    },
    [getStudentAttendance.rejected]: (state) => {
      state.loading = false;
    },

    [saveStudentAttendance.pending]: (state) => {
      state.loading = true;
    },
    [saveStudentAttendance.fulfilled]: (state, action) => {
      state.loading = false;
      state.lastAdded = action.payload.params;
    },
    [saveStudentAttendance.rejected]: (state) => {
      state.loading = false;
    },

    [updateStudentAttendanceStaff.pending]: (state) => {
      state.loading = true;
    },
    [updateStudentAttendanceStaff.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateStudentAttendanceStaff.rejected]: (state) => {
      state.loading = false;
    },

    [uploadStudentAttendance.pending]: (state) => {
      state.loading = true;
    },
    [uploadStudentAttendance.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [uploadStudentAttendance.rejected]: (state) => {
      state.loading = false;
    },

    [getStudentAttendanceDetails.pending]: (state) => {
      state.loading = true;
    },
    [getStudentAttendanceDetails.fulfilled]: (state, action) => {
      //console.log("getStudentAttendanceDetails", action.payload);
      state.loading = false;
      state.studentAttendance = action.payload;
    },
    [getStudentAttendanceDetails.rejected]: (state) => {
      state.loading = false;
    },

    [getStaffAttendanceDetails.pending]: (state) => {
      state.loading = true;
    },
    [getStaffAttendanceDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.staffAttendance = action.payload;
    },
    [getStaffAttendanceDetails.rejected]: (state) => {
      state.loading = false;
    },

    [getAttendancePercentage.pending]: (state) => {
      state.loading = true;
      state.studentAttendancePercentage = null;
    },
    [getAttendancePercentage.fulfilled]: (state, action) => {
      state.loading = false;
      state.studentAttendancePercentage = action.payload.attendancePercentage;
    },
    [getAttendancePercentage.rejected]: (state) => {
      state.loading = false;
    },
    [getStudentAttendancePercentageDateRangeDepartmentWise.pending]: (
      state
    ) => {
      state.loading = true;
      state.studentAttendancePercentageDateRangeDepartmentWise = null;
    },
    [getStudentAttendancePercentageDateRangeDepartmentWise.fulfilled]: (
      state,
      action
    ) => {
      state.loading = false;
      state.studentAttendancePercentageDateRangeDepartmentWise = action.payload;
    },
    [getStudentAttendancePercentageDateRangeDepartmentWise.rejected]: (
      state
    ) => {
      state.loading = false;
      state.studentAttendancePercentageDateRangeDepartmentWise = null;
    },
    [getStudentAttendancePercentageYearWise.pending]: (state) => {
      state.loading = true;
      state.studentAttendancePercentageYearWise = null;
    },
    [getStudentAttendancePercentageYearWise.fulfilled]: (state, action) => {
      state.loading = false;
      state.studentAttendancePercentageYearWise = action.payload;
    },
    [getStudentAttendancePercentageYearWise.rejected]: (state) => {
      state.loading = false;
      state.studentAttendancePercentageYearWise = null;
    },

    [downloadTemplate.pending]: (state) => {
      state.loading = true;
    },
    [downloadTemplate.fulfilled]: (state, action) => {
      state.loading = false;
      state.fileUrl = action.payload;
    },
    [downloadTemplate.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const {
  resetState,
  resetUrl,
  getCurrentData,
  clearIndex,
  addStudentData,
  setStudentName,
  resetStudentAtttendance,
  resetStaffAtttendance,
  clearStudentAttendancePercentage,
  setPerPage,
  setOffset,
  setPage, 
} = attendanceSlice.actions;

export default attendanceSlice.reducer;

export {
  resetState,
  getStudentAttendance,
  uploadStudentAttendance,
  downloadTemplate,
  resetUrl,
  getStudentAttendanceDetails,
  getStaffAttendanceDetails,
  getAttendancePercentage,
  getCurrentData,
  updateStudentAttendanceStaff,
  clearIndex,
  saveStudentAttendance,
  addStudentData,
  setStudentName,
  resetStudentAtttendance,
  resetStaffAtttendance,
  getStudentAttendancePercentageDateRangeDepartmentWise,
  getStudentAttendancePercentageYearWise,
  clearStudentAttendancePercentage,
  
  setPerPage,
  setOffset,
  setPage,
};
